import { DotDangKyThiSinhService } from "../services/dotdangkythisinh.service";

var dotDangKyThiSinh = {
	id: "",
	dotDangKyId: "",
	thiSinhId: "",
	regCode: "",
	changeCount: "",
	status: "",
};

var state = {
	dotdangkythisinh: { ...dotDangKyThiSinh },
};

var getters = {};

var mutations = {
	saveDotDangKy(state, data) {
		state.dotdangkythisinh = data;
	},
};

var actions = {
	createDotDangKyThiSinh({ commit, rootState }, payload) {
		return DotDangKyThiSinhService.createDotDangKyThiSinh({
			dotDangKyId: rootState.dotdangky.dotdangky.dotDangKyId,
			thiSinhId: payload.thiSinhId,
			regCode: "",
			changeCount: 0,
			status: "moitao",
		})
			.then(async (response) => {
				if (response.status === 201) {
					await commit("saveDotDangKy", response.data);
				}
				return response;
			})
			.catch((error) => error.message);
	},

	updateDotDangKyThiSinh({ commit, rootState }, payload) {
		return DotDangKyThiSinhService.updateDotDangKyThiSinh({
			id: payload.id,
			dotDangKyId: rootState.dotdangky.dotdangky.dotDangKyId,
			thiSinhId: payload.thiSinhId,
			regCode: payload.regCode,
			changeCount: payload.changeCount,
			status: payload.status,
		})
			.then((response) => {
				if (response.status === 204) {
					commit("saveDotDangKy", response.data);
				}
				return response;
			})
			.catch((error) => error.message);
	},

	getDotDangKyThiSinh({ commit }, payload) {
		return DotDangKyThiSinhService.getDotDangKyThiSinh({
			thiSinhId: payload.thiSinhId,
			regCode: payload.regCode,
		})
			.then((response) => {
				if (response.status === 200) commit("saveDotDangKy", response.data);
				return response;
			})
			.catch((error) => error.message);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
